"use strict";function openSingleChat$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openSingleChat$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.chat.openSingleChat";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.4.10"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.4.10"},_a)),exports.openSingleChat$=openSingleChat$,exports.default=openSingleChat$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/chat/openSingleChat.js
// module id = 919
// module chunks = 106